import Vue from 'vue'
import { Loading } from 'element-ui';
// loading框设置局部刷新，且所有请求完成后关闭loading框
let loading={}
function startLoading (targetdq) {
    if(loading[targetdq]){
        return
    }
    let load= Loading.service({
        lock: true,
        text: '加载中...',
        background: 'rgba(255,255,255,.4)',
        target: document.querySelector(targetdq) // 设置加载动画区域
    })
    Vue.set(loading,targetdq,load)
}
 
function endLoading (targetdq) {
    let load = loading[targetdq]
    if (load) {
        load.close()
        Vue.delete(loading,targetdq)
    }
}
export function showLoading (targetdq) {
    startLoading(targetdq)
}
export function hideLoading (targetdq) {
    endLoading(targetdq)
}
 
export default {
    showLoading,
    hideLoading
}